import { TFunction } from "react-i18next";
import * as yup from "yup";
import { ChannelDataOrder } from "../context/types";
import { NavigateFunction } from "react-router-dom";
import { CSSProperties } from "react";

export interface ICountry {
  CountryDesc: string;
  CountryID: number;
  CountryLanguageID: number;
  CountryParameters: Array<ICountryParameters>;
}

type ICountryParameters = {
  Id: number;
  Dsc: string;
  Val: string;
};

export const loginSchema = yup.object({
  username: yup.string().max(80),
  password: yup.string().max(80),
});

export interface ILogin extends yup.InferType<typeof loginSchema> {
  username: string;
  password: string;
  countryId: number;
  terms: boolean;
  keepConnected: boolean;
  language?: string;
}

export interface IPropsForm {
  login: ILogin;
  setLogin?: React.Dispatch<React.SetStateAction<ILogin>>;
}

export interface ButtonProps {
  login: ILogin;
  handleClick(): void;
  loading: boolean;
  t: TFunction<"translation", undefined>;
}
export interface Recovery {
  email: string;
  countryID: number;
}
export interface IChannelDataIconOption {
  orderType: ChannelDataOrder;
  titleOrderType0?: string;
  titleOrderType1?: string;
}

export interface IUserPreferenceContext {
  userPreference: any; 
  userTarget: any;
  doUserPreference: (isUpdate?: boolean) => Promise<void>; 
  userPost: (target?: boolean) => Promise<void>; 
  updateUserPreference: (userData: any) => void;  
  userAuthenticated: boolean ;
  setUserAuthenticated: React.Dispatch<React.SetStateAction<boolean>>;
  horaIniCalendar: string | undefined;
  setHoraIniCalendar: React.Dispatch<React.SetStateAction<string | undefined>>;
  horaFinCalendar: string | undefined;
  setHoraFinCalendar: React.Dispatch<React.SetStateAction<string | undefined>>;
  userMenssageApi: string | undefined;
  setUserMenssageApi: React.Dispatch<React.SetStateAction<string | undefined>>;  
  loaded : boolean;
  setLoaded: React.Dispatch<React.SetStateAction<boolean>>;
  minuteImage : number | false;
  setMinuteImage: React.Dispatch<React.SetStateAction<number>>;
  setUserPreference: React.Dispatch<React.SetStateAction<any>>;
  setUserTarget: React.Dispatch<React.SetStateAction<any>>;
}

export interface IForgotState {
  clickedForgot: boolean;
  setClickedForgot: React.Dispatch<React.SetStateAction<boolean>>;
}

export interface IDateAudienceData {
  day?: number;
  month?: number;
  year?: number;
  fullDate: Date
  fullDateFormat: string
}


export interface IChangePasswordActionData {
  token: string  | null;
  oldPassword: string;
  newPassword: string;
  newConfirmPassword: string;
  countryId: number;
  language: string;
}   

export interface IExpiredPasswordActionData {
  UserName: string;
  CountryId: number;
  Password: string;
  NewPassword: string;
  ConfirmationPassword: string;
}   

export interface ImageWithFallbackProps {
  dataid: string;
  title: string;
  src: string;
  style: CSSProperties;
  className: string;
  showTitle: boolean;
}
export interface ImageWithFallbackState {
  errored: boolean;
  id: string;
}


export interface IForgotPasswordRequest {
  location: any;
  navigate: NavigateFunction;
  searchParam: string;
  pathToCheck: string;
  pathToRedirect: string;
  paramsGet: IForgotPasswordParams[];
}
export interface IForgotPasswordParams {
  key: string;
  value: string | undefined | null;
}

export interface IForgotPasswordRequestState {
  urlParamForgotPassword: IForgotPasswordParams[];
  actionPath: string | undefined | null;
}

export interface IDataCollectionMap {
  Data: any;
  dataID: number;
}
